import { CloseOutlined, DeleteOutline } from '@mui/icons-material'
import { Autocomplete, Box, Button, Checkbox, Chip, Drawer, FormControl, FormControlLabel, FormHelperText, FormLabel, IconButton, List, ListItem, ListItemText, MenuItem, Paper, Radio, RadioGroup, Select, TextField, Typography, useTheme } from '@mui/material'
import { useEffect, useState } from 'react';

import { HttpStatusCode } from 'axios';
import { useApplicationContext } from '../../../../context/ApplicationContext';

import TemplateLoaderComponent from '../../../loader/TemplateLoaderComponent';
import useErrorHandler from '../../../../api/errorHandler/useErrorHandler';
import { LicenseDuration, PlanBilling, Severity } from '../../../../constant/ApplicationVariables';

import { createRole_API, getPermissionList_API, } from '../../../../api/controller/RolesController';
import { updateLicense_API } from '../../../../api/controller/LicenseController';




export default function EditLicensePackageComponent({ open, handleClose, handleContinue }) {
  const { handleSnackbar, currentLicenseData, setCurrentLicenseData, licenseList, setLicenseList, } = useApplicationContext();
  const theme = useTheme();
  const errorHandler = useErrorHandler();

  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({
    code: "",
    name: "",
    description: "",
    planBilling: PlanBilling.monthly,
    basePrice: 10,
    includedUsers: 5,
  });
  const [featuresInputText, setFeaturesInputText] = useState("");


  const [error, setError] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    validateInputs();
  }

  const handleChange = (e) => {
    if (e.target.name === "featuresInputText") {
      setFeaturesInputText(e.target.value);
    } else if (e.target.name === "active") {
      setUserData({ ...userData, [e.target.name]: e.target.checked });
    } else {
      setUserData({ ...userData, [e.target.name]: e.target.value });
    }
  }




  const validateInputs = () => {


    let errorObject = {};

    if (!userData?.code) {
      errorObject = { ...errorObject, code: "Code is required" };
    } else if (userData?.code?.length < 3) {
      errorObject = { ...errorObject, code: "Code must be at least 3 characters" };
    } else {
      delete errorObject.code;
    }

    if (!userData?.name) {
      errorObject = { ...errorObject, name: "Name is required" };
    } else if (userData?.name?.length < 3) {
      errorObject = { ...errorObject, name: "Name must be at least 3 characters" };
    } else {
      delete errorObject.name;
    }

    if (!userData?.description) {
      errorObject = { ...errorObject, description: "Description is required" };
    } else if (userData?.description?.length < 3) {
      errorObject = { ...errorObject, description: "Description must be at least 3 characters" };
    } else {
      delete errorObject.description;
    }

    if (userData?.basePrice === 0 || userData?.basePrice === null || userData?.basePrice === undefined) {
      errorObject = { ...errorObject, basePrice: "Base Price is required" };
    } else if (isNaN(userData?.basePrice) || userData?.basePrice < 0) {
      errorObject = { ...errorObject, basePrice: "Base Price must be a positive number" };
    } else {
      delete errorObject.basePrice;
    }

    if (userData?.includedUsers === 0 || userData?.includedUsers === null || userData?.includedUsers === undefined) {
      errorObject = { ...errorObject, includedUsers: "Included Users is required" };
    } else if (isNaN(userData?.includedUsers) || userData?.includedUsers < 0) {
      errorObject = { ...errorObject, includedUsers: "Included Users must be a positive number" };
    } else {
      delete errorObject.includedUsers;
    }

    setError(errorObject);

    if (Object.keys(errorObject).length > 0) {
      return;
    }



    handleUpdate();
  }


  const handleUpdate = async () => {
    try {
      setLoading(true);

      let body = {
        code: userData?.code,
        // newCode: "",
        name: userData?.name,
        description: userData?.description,
        basePrice: userData?.basePrice,
        includedUsers: userData?.includedUsers,
        planBilling: userData?.planBilling,
        active: userData.active
      }

      if (body.code !== currentLicenseData.code) {
        body.newCode = body.code;
        body.code = currentLicenseData.code;
      }

      const response = await updateLicense_API(body);

      if (response) {
        if (response.status === HttpStatusCode.NotAcceptable) {
          let errorVar = {};

          Object.keys(response?.response.data.fields || {})?.forEach((key) => {
            let errorKeyName = key === "newCode" ? "code" : key;
            errorVar[errorKeyName] = response?.response.data?.fields[key];
          });

          setError(errorVar === "{}" ? null : errorVar)
          console.log(response, error, "fields errorr");
        } else {
          setError(null);
          errorHandler(response, setLoading);
        }
      }

      if (response.status === HttpStatusCode.Ok) {
        let list = [...licenseList];

        let key = body.newCode ? "code" : "code";

        let foundIndex = list.findIndex(item => item.code === currentLicenseData[key]);
        if (foundIndex !== -1) {
          list[foundIndex] = response.data;
        }
        setLicenseList(list);


        handleContinue();
      }


      console.log(response, "categoryreponse data")
    } catch (error) {
      console.log(error, "categoryreponse errorr")
      handleSnackbar(String(error), Severity.error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 100);
    }
  }

  useEffect(() => {
    if (currentLicenseData) {
      setUserData(currentLicenseData);
    }
  }, [currentLicenseData])

  console.log(userData, "userDatacreate error", error);
  console.log(Object.entries(LicenseDuration), "entries")

  return (
    <Drawer
      open={open}
      anchor="right"
      onClose={handleClose}
    // sx={{ "& .MuiDrawer-paper": { width: { xs: "100%", sm: "100%" } } }}
    >
      <Box className="flex flex-col w-[400px] h-full">


        {/* header */}
        <Box className="flex items-center justify-between px-4 py-2 gap-2 w-full border-b">
          <Typography color="textPrimary">Update Plan</Typography>

          <IconButton onClick={handleClose}>
            <CloseOutlined />
          </IconButton>
        </Box>

        {/* main container */}
        <Box component={"form"} onSubmit={handleSubmit} className="flex-1 flex flex-col px-0 py-0 gap-4 relative " >
          <Box className="flex-1 flex flex-col px-4 py-4 gap-4 relative overflow-y-auto" sx={{ gap: theme.spacing(4) }}>


            {loading && <TemplateLoaderComponent />}

            <FormControl required error={error?.code && error?.code}>
              <FormLabel htmlFor="code">Code</FormLabel>
              <TextField id="code" name="code" value={userData?.code} onChange={handleChange} error={error?.code && error?.code} helperText={error?.code && error?.code} />
            </FormControl>

            <FormControl required error={error?.name && error?.name}>
              <FormLabel htmlFor="name">Name</FormLabel>
              <TextField id="name" name="name" value={userData?.name} onChange={handleChange} error={error?.name && error?.name} helperText={error?.name && error?.name} />
            </FormControl>

            <FormControl required error={error?.description && error?.description}>
              <FormLabel htmlFor="description">Description</FormLabel>
              <TextField id="description" name="description" multiline rows={4} value={userData?.description} onChange={handleChange} error={error?.description && error?.description} helperText={error?.description && error?.description} />
            </FormControl>

            <FormControl required error={error?.planBilling && error?.planBilling} >
              <FormLabel htmlFor="planBilling">Duration</FormLabel>
              <Box className="flex flex-wrap gap-1">
                {Object.entries(LicenseDuration)?.map(([key, item], index) => {
                  return (
                    <Chip key={index} label={item} color={userData?.planBilling === item ? "secondary" : "default"} onClick={() => setUserData({ ...userData, planBilling: item })} sx={{ mb: 1 }} />
                  )
                })}
              </Box>
              <FormHelperText color="error" >{error?.planBilling && error?.planBilling}</FormHelperText>
            </FormControl>

            <FormControl required error={error?.basePrice && error?.basePrice}>
              <FormLabel htmlFor="basePrice">Price</FormLabel>
              <TextField type="number" id="basePrice" name="basePrice" value={userData?.basePrice} onChange={handleChange} error={error?.basePrice && error?.basePrice} helperText={error?.basePrice && error?.basePrice} />
            </FormControl>


            <FormControl required error={error?.includedUsers && error?.includedUsers}>
              <FormLabel htmlFor="includedUsers">Included Users Count</FormLabel>
              <TextField type="number" id="includedUsers" name="includedUsers" value={userData?.includedUsers} onChange={handleChange} error={error?.includedUsers && error?.includedUsers} helperText={error?.includedUsers && error?.includedUsers} />
            </FormControl>


            <FormControl required error={error?.active && error?.active}>
              <FormLabel id="active-radio-group-label">Status</FormLabel>
              <RadioGroup
                aria-labelledby="active-radio-group-label"
                name="active"
                value={userData?.active === true ? "true" : "false"}
                onChange={e => setUserData({ ...userData, active: e.target.value === "true" })}
                row
                color="secondary"
              >
                <FormControlLabel value="true" label="Active" control={<Radio color="secondary" />} />
                <FormControlLabel value="false" label="Inactive" control={<Radio color="secondary" />} />
              </RadioGroup>
              <FormHelperText color="error" >{error?.active && error?.active}</FormHelperText>
            </FormControl>



          </Box>


          {/* footer */}
          <Box className="flex items-center px-4 py-4 gap-2 w-full border-t">
            <Button fullWidth variant="outlined" disabled={loading} onClick={handleClose}>Cancel</Button>
            <Button type="submit" fullWidth variant="contained" color="secondary" disabled={loading} onClick={handleSubmit}>Update</Button>
          </Box>
        </Box>

      </Box>
    </Drawer>

  )
}
